import React, { Component } from 'react';
import Social from '../components/social';
import globalizacao from '../escolha/globalizacao';

class Contact extends Component {

    componentDidMount() {

        //   window.scrollTo(0, 0);

    }

    render() {
        return (
            <section className="secao inner-page contato fundo-white">
                <div className="limite conteudo">
                    <h2>{globalizacao.msg("contato")}</h2>

                    <ul className="lista listaB">
                        <li>
                            <strong>Email:</strong>
                            {" "}<a href="mailto:contato@escolhatecnologia.com.br" >contato@escolhatecnologia.com.br</a></li>
                        <li>
                            {" "} <strong>Whatsapp:</strong>
                            {" "}
                            <a
                                id="btnAddContato"
                                href="tel:+5518998058975"
                                style={{
                                    display: "inline-block"
                                }}>
                                +55(Brazil) 18-99805-8975
                        </a>
                        </li>
                    </ul>
                    <Social />
                </div>

            </section>
        );
    }
}

export default Contact;
